// Stable, first-party visitor identity for our own analytics.
// - visitorId: persistent per-browser UUID (localStorage) — primary identity.
// - sessionId: per-tab-session UUID (sessionStorage).
// If storage is unavailable/blocked, these return '' and the server falls back
// to a cookieless IP+User-Agent daily hash (the "hybrid" identity strategy).

const VISITOR_KEY = 'pmVisitorId';
const SESSION_KEY = 'pmSessionId';

function uuid() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (e) {
    // fall through to manual generation
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch (e) {
    return '';
  }
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = uuid();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch (e) {
    return '';
  }
}
